import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { enumAttributeConverter } from '../enum-types';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlHeadingPlaceholderProps } from './placeholders.props';

import * as PlaceholderTags from './placeholders.tagnames';
import { HeadingPlaceholderVariant, SpanPlaceholderSizes } from './placeholders.enums';

@customElement(PlaceholderTags.Heading)
export class AtlHeadingPlaceholder extends LitElement implements AtlHeadingPlaceholderProps {
    declare isLong?: boolean;
    declare bigMarginTop?: boolean;
    declare variant?: HeadingPlaceholderVariant;

    static properties = {
        isLong: { attribute: 'is-long', type: Boolean },
        bigMarginTop: { attribute: 'big-margin-top', type: Boolean },
        variant: { type: String, converter: enumAttributeConverter(HeadingPlaceholderVariant, HeadingPlaceholderVariant.h1)  }
    }

    static styles = [
        ...getGlobalStyleSheets(),
        css`.placeholder-glow { animation: placeholder-glow 2s ease-in-out infinite; }`
    ];

    render() {        
        return html`
            <div class="placeholder-glow ${this.variant} ${this.bigMarginTop ? "mt-lg-5" : "mt-4"}">
                <atlantis-span-placeholder size=${this.isLong ? SpanPlaceholderSizes.Larger : SpanPlaceholderSizes.Medium}>
                </atlantis-span-placeholder>
            </div>
        `;
    }
}